<template>
	<div class="footer-components">
		<el-footer height="160px">
			<div class="footer-content">
				<div class="bottom-box">
					<div class="line-box">
						<div class="item" @click="toPath('img', 'license')">(鲁)经营性-2023-0030（证照编号）</div>
						<div class="item" @click="toPath('ICP');">鲁ICP备2023008583号（ICP备案编号）</div>
						<div class="item"><img src="../assets/images/ga.png">鲁公网安备37010102001725号（公安网备案）</div>
					</div>
					<div class="line-box">
						<div class="item">
							<a href="https://syjk-oss.sypmyoulecai.com/syjk-purchase/html/user-agree.html" target="view_window">用户协议</a>
						</div>
						<div class="item" @click="toPath('img', 'license')">药品经营许可证</div>
						<div class="item" @click="toPath('img', 'license')">医疗器械经营许可证</div>
						<div class="item" @click="toPath('img', 'license')">第二类医疗器械备案凭证</div>
						<div class="item" @click="toPath('img', 'license')">食品经营许可证</div>
					</div>
					<div class="line-box">
						<div class="item bold">客服热线：0531-87935508</div>
						<div class="item">Copyright©2022 - {{year}} 山东枫藤数字科技股份有限公司 版权所有</div>
					</div>
				</div>
			</div>
		</el-footer>
	</div>
</template>

<script>
	export default {
		name: "vFooter",
		data() {
			return {
				year: new Date().getFullYear()
			}
		},
		methods: {
			toPath(type, key) {
				let url = process.env.VUE_APP_WEB_LOCATION;

				if (type === 'YJCX') {
					window.open('https://www.nmpa.gov.cn/datasearch/home-index.html')
				} else if (type === 'ICP') {
					window.open('https://beian.miit.gov.cn')
				} else if (type === 'img') {
					window.open(url + '/#/license?key=' + key)
				}
			}
		}
	};
</script>

<style lang="scss" rel="stylesheet/scss">
	.footer-components {
		.el-footer {
			padding: 40px 0;
			background-color: #FFFFFF;

			.footer-content {
				margin: 0 auto;
				padding: 0 20px;
				width: 1240px;
				min-width: 1240px;

				.bottom-box {
					.line-box {
						display: flex;
						justify-content: center;
						align-items: center;
						margin-top: 4px;

						.item {
							margin-left: 9px;
							padding-right: 9px;
							font-size: 12px;
							color: #999999;
							cursor: pointer;
							
							img {
								margin-right: 4px;
								margin-bottom: -2px;
								width: 14px;
							}
							
							a {
								color: #999999 !important;
							}
						}

						.bold {
							color: #666666;
							font-weight: bold;
						}

						.line {
							position: relative;
							margin-left: 12px !important;
							padding-right: 12px !important;
						}

						.line:last-child::before {
							content: none;
						}

						.line::before {
							content: '';
							position: absolute;
							top: 50%;
							right: 0;
							transform: translateY(-50%);
							height: 12px;
							width: 1px;
							background-color: #999999;
						}
					}
				}
			}
		}
	}
</style>